import styled from 'styled-components';
import { FILTERS_HEIGHT } from '@/app/common/constants.ts';
import { HorizontalScrollContainerStyled } from '@/app/common/components/HorizontalScrollContainer';
import { pillTrailingSpace } from '@/app/common/components/Pill/styled.ts';

export const SwipeLayoutContainer = styled(HorizontalScrollContainerStyled)`
  height: ${FILTERS_HEIGHT}px;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};

  ${pillTrailingSpace};
`;
